var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FiltersPresenter_instances, _FiltersPresenter_store, _FiltersPresenter_view, _FiltersPresenter_syncViewWithStore, _FiltersPresenter_initEvents;
import Emitter from '@helpers/Emitter';
import { FILTERS_PRESENTER_EVENTS, FILTERS_STORE_EVENTS, FILTERS_VIEW_EVENTS, } from '@resources/js/components/filters/filterEvents';
class FiltersPresenter extends Emitter {
    constructor(view, store) {
        super();
        _FiltersPresenter_instances.add(this);
        _FiltersPresenter_store.set(this, void 0);
        _FiltersPresenter_view.set(this, void 0);
        __classPrivateFieldSet(this, _FiltersPresenter_view, view, "f");
        __classPrivateFieldSet(this, _FiltersPresenter_store, store, "f");
        __classPrivateFieldGet(this, _FiltersPresenter_instances, "m", _FiltersPresenter_initEvents).call(this);
        __classPrivateFieldGet(this, _FiltersPresenter_instances, "m", _FiltersPresenter_syncViewWithStore).call(this);
    }
}
_FiltersPresenter_store = new WeakMap(), _FiltersPresenter_view = new WeakMap(), _FiltersPresenter_instances = new WeakSet(), _FiltersPresenter_syncViewWithStore = function _FiltersPresenter_syncViewWithStore() {
    __classPrivateFieldGet(this, _FiltersPresenter_view, "f").update(__classPrivateFieldGet(this, _FiltersPresenter_store, "f").getData());
}, _FiltersPresenter_initEvents = function _FiltersPresenter_initEvents() {
    __classPrivateFieldGet(this, _FiltersPresenter_view, "f").on(FILTERS_VIEW_EVENTS.APPLY, changes => {
        __classPrivateFieldGet(this, _FiltersPresenter_store, "f").applyChanges(changes);
        this.emit(FILTERS_PRESENTER_EVENTS.APPLY);
    });
    __classPrivateFieldGet(this, _FiltersPresenter_store, "f").on(FILTERS_STORE_EVENTS.CHANGE, (changes) => {
        __classPrivateFieldGet(this, _FiltersPresenter_view, "f").update(changes);
        this.emit(FILTERS_PRESENTER_EVENTS.CHANGE, __classPrivateFieldGet(this, _FiltersPresenter_store, "f").getData());
    });
    __classPrivateFieldGet(this, _FiltersPresenter_store, "f").on(FILTERS_STORE_EVENTS.CLEAR, () => {
        __classPrivateFieldGet(this, _FiltersPresenter_view, "f").clear();
    });
};
export default FiltersPresenter;
